var React = require('react');

function SDCDownload22N (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m14.08223,10.42981l-2.33223,2.5119V2.5c0-.27614-.22386-.5-.5-.5h-.5c-.27614,0-.5.22386-.5.5v10.44171l-2.33223-2.5119c-.18786-.20233-.50417-.2141-.70654-.02628l-.3666.34023c-.20245.18788-.21421.50433-.02626.70672l3.81525,4.10857c.19781.21302.53497.21302.73278,0l3.81525-4.10857c.18794-.20239.17618-.51884-.02626-.70672l-.3666-.34023c-.20238-.18782-.51868-.17605-.70654.02628h-.00002Z","fill":"var(--iconFill, #464646)","key":0}),React.createElement("path",{"d":"m18.75,20H3.25c-.69036,0-1.25-.55964-1.25-1.25v-4.25c0-.27614.22386-.5.5-.5h.5c.27614,0,.5.22386.5.5v4h15v-4c0-.27614.22386-.5.5-.5h.5c.27614,0,.5.22386.5.5v4.25c0,.69036-.55964,1.25-1.25,1.25Z","fill":"var(--iconFill, #464646)","key":1})]);
}

SDCDownload22N.defaultProps = {"id":"ImportedIcons","width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = SDCDownload22N;

SDCDownload22N.default = SDCDownload22N;
